import { render } from "./study_groups.vue?vue&type=template&id=b435ea5a"
import script from "./study_groups.vue?vue&type=script&lang=js"
export * from "./study_groups.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__